import { useState } from "react";
import { Sheet, SheetContent, SheetTrigger } from "./ui/sheet";
import { Button } from "./ui/button";
import { Menu, Phone } from "lucide-react";

const NAV = [
  { label: "About Us", href: "#about", id: "about" },
  { label: "Services", href: "#services", id: "services" },
  { label: "Order Diesel", href: "#order", id: "order" },
  { label: "Our Fleet", href: "#fleet", id: "fleet" },
  { label: "Contact", href: "#contact", id: "contact" },
];

export const Logo = ({ compact = false }) => (
  <a href="#home" className="flex items-center gap-3" data-testid="brand-logo">
    <svg width="40" height="40" viewBox="0 0 64 64" aria-hidden="true">
      <rect width="64" height="64" rx="14" fill="#1C2541" stroke="#F57C00" strokeWidth="2" />
      <path d="M14 50 L14 18 L23 34 L32 18 L41 34 L50 18 L50 50" stroke="#F57C00" strokeWidth="6" fill="none" strokeLinejoin="round" strokeLinecap="round" />
    </svg>
    <span className="leading-tight">
      <span className={`font-display font-800 tracking-wide text-white block ${compact ? "text-base" : "text-lg"} font-extrabold`}>MOTAPS GLOBAL</span>
      {!compact && <span className="text-[10px] tracking-[0.3em] text-amber-500 uppercase block">Investment Limited</span>}
    </span>
  </a>
);

export default function Header() {
  const [open, setOpen] = useState(false);
  return (
    <header className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-[#0B132B]/80 border-b border-slate-700/50" data-testid="site-header">
      <div className="max-w-7xl mx-auto px-5 md:px-8 h-[72px] flex items-center justify-between">
        <Logo />
        <nav className="hidden lg:flex items-center gap-8" data-testid="desktop-nav">
          {NAV.map((item) => (
            <a
              key={item.id}
              href={item.href}
              data-testid={`nav-link-${item.id}`}
              className="text-sm font-medium text-slate-300 hover:text-amber-500 transition-colors duration-200"
            >
              {item.label}
            </a>
          ))}
        </nav>
        <div className="hidden lg:flex items-center gap-4">
          <a href="tel:+2347063792622" data-testid="header-phone-link" className="flex items-center gap-2 text-sm text-slate-300 hover:text-amber-500 transition-colors">
            <Phone size={16} className="text-amber-500" /> +234 706 379 2622
          </a>
          <Button asChild className="bg-amber-600 hover:bg-amber-500 text-white rounded-full px-6 transition-colors duration-200">
            <a href="#order" data-testid="header-order-btn">Order Diesel</a>
          </Button>
        </div>
        <Sheet open={open} onOpenChange={setOpen}>
          <SheetTrigger asChild>
            <button className="lg:hidden text-slate-200 p-2" data-testid="mobile-menu-button" aria-label="Open menu">
              <Menu size={26} />
            </button>
          </SheetTrigger>
          <SheetContent side="right" className="bg-[#1C2541] border-slate-700 text-slate-100 w-72">
            <div className="mt-8 flex flex-col gap-6" data-testid="mobile-nav">
              {NAV.map((item) => (
                <a
                  key={item.id}
                  href={item.href}
                  onClick={() => setOpen(false)}
                  data-testid={`mobile-nav-link-${item.id}`}
                  className="text-lg font-display font-semibold text-slate-200 hover:text-amber-500 transition-colors"
                >
                  {item.label}
                </a>
              ))}
              <a href="tel:+2347063792622" data-testid="mobile-phone-link" className="flex items-center gap-2 text-amber-500 font-semibold">
                <Phone size={18} /> +234 706 379 2622
              </a>
            </div>
          </SheetContent>
        </Sheet>
      </div>
    </header>
  );
}
